module.exports = __webpack_public_path__ + "img/9.4a2f7287.webp";